module.exports = __webpack_public_path__ + "img/banner03_01.e981fe8c.png";